var map = {
	"./1.png": "f9a3",
	"./10.png": "ef11",
	"./2.png": "41c0",
	"./3.png": "e3f9",
	"./4.png": "b9e3",
	"./5.png": "f184",
	"./6.png": "234a",
	"./7.png": "988b",
	"./8.png": "ba0e",
	"./9.png": "2a1a",
	"./bg.png": "42e8",
	"./icon1.png": "c2ba",
	"./icon2.png": "b318",
	"./icon3.png": "dd36",
	"./icon4.png": "3afb",
	"./icon5.png": "bfd9",
	"./icon6.png": "309d",
	"./icon7.png": "001e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1650";